App.load('yarn::leaflet-draw/dist/leaflet.draw-src')
App.load('core::leaflet/GeoUtil')
App.load('core::leaflet/MassEvents')
App.load('core::leaflet/mfdraw/L.Control.MFDraw')
App.load('core::leaflet/GeomUndoStack')
App.load('core::leaflet/Leaflet.draw/draw/Draw.BetterCircle')
App.load('core::leaflet/Leaflet.draw/draw/Draw.Polyline')
App.load('core::leaflet/Leaflet.draw/edit/Edit.BetterPoly')
App.load('core::leaflet/Leaflet.draw/edit/Edit.PolyWithHoles')
App.load('core::leaflet/layers/vector/PolyCircle')
App.load('core::leaflet/L.Control.MfButtonGrid')
App.load('core::leaflet/L.Control.MfDraw')
App.load('core::leaflet/L.Control.MfMarker')
App.load('core::leaflet/L.Control.MfPolygon')
App.load('core::leaflet/L.Control.MfPolyline')
App.load('bower::leaflet.markerclusterer/dist/leaflet.markercluster-src')
App.load('core::leaflet/CustomMethods')
App.load('core::leaflet/MfMarkerClusterGroup')
